import PQueue from 'p-queue/dist'

export const queue = new PQueue({ concurrency: 15 })
